import { createFileRoute } from '@tanstack/react-router';

import { SiteContentPage } from '@/features/owner/site/SiteContentPage';

export const Route = createFileRoute('/_authed/owner/site/content')({
  component: SiteContentPage,
});
